import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { SELECT_VENUE_ROUTE } from '@constants/routes';
import { CompanyAuthContext } from '@contexts/company-auth-context/company-auth-context';
import { FeatureFlagContext } from '@contexts/featureFlag/featureFlag-context';
import { useIsProtectedElement } from '@hooks/use-is-protected-element';
import { useToast } from '@hooks/use-toast/use-toast';

import { ProtectedComponentProps } from './protected-component.type';

export const ProtectedComponent = ({
  permissions,
  children,
  isRoute,
  isPublicEventReportPage,
  checkEveryPermission = true,
}: ProtectedComponentProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const toast = useToast();
  const { isFinished } = useContext(CompanyAuthContext);
  const { isCompanyAuthEnabled } = useContext(FeatureFlagContext);
  const isVisible = useIsProtectedElement({ permissions, checkEveryPermission });

  if (!isVisible && isCompanyAuthEnabled && !isPublicEventReportPage) {
    if (isRoute && isFinished) {
      toast.push({
        title: t('errors:errorPermissionAccessRouter'),
        text: '',
        type: 'error',
        disableTimeOut: true,
      });
      navigate(SELECT_VENUE_ROUTE);
    }
    return null;
  }

  return children;
};
